export default __webpack_public_path__ + "static/6-2cdc3e80861eb96c5261244d91fd7229.png";